import { reverse } from 'named-urls'
import React from 'react'

import { StatusTag } from '@components'
import { ButtonClean } from '@fourthwall/components'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'
import { routing } from '@utils/routing'

import * as S from './AnalyticsProductLabel.styled'

type AnalyticsProductLabelProps = {
  name: string
  status?: string
  productId?: string
}

export const AnalyticsProductLabel = ({ name, status, productId }: AnalyticsProductLabelProps) => {
  const productName = decodeHtmlEntities(name)

  if (status === 'ARCHIVED') {
    return (
      <S.Container>
        {productName}
        <StatusTag status={status} size="small" />
      </S.Container>
    )
  }

  if (productId) {
    return (
      <ButtonClean
        label={productName}
        // TODO: Handle offer type to provide proper link
        to={reverse(routing.products.all.product.self, { productId })}
      />
    )
  }

  return productName
}
